import type { Column } from '@tanstack/react-table'
import Icon from '@components/utils/Icon'
import cn from '@components/utils/cn'

type SortableHeaderProps<T> = {
  column: Column<T>
  children: React.ReactNode
  className?: string
}

export function SortableHeader<T>({ column, children, className }: SortableHeaderProps<T>) {
  return (
    <button
      className={cn('tw:flex tw:items-center tw:gap-1 tw:font-bold tw:hover:text-gray-900', className)}
      onClick={() => {
        column.toggleSorting(column.getIsSorted() === 'asc')
      }}
    >
      {children}
      {column.getIsSorted() === 'asc' && <Icon type="sort-ascending" width={14} height={14} />}
      {column.getIsSorted() === 'desc' && <Icon type="sort-descending" width={14} height={14} />}
    </button>
  )
}
